import UserAvatar from 'app/shared-components/user/UserAvatar';
import UserName from 'app/shared-components/user/UserName';
import Button from '@mui/material/Button';
import Card from '@mui/material/Card';
import CardHeader from '@mui/material/CardHeader';
import { ChatBubbleLeftRightIcon } from '@heroicons/react/24/outline'
import formatDistanceToNow from 'date-fns/formatDistanceToNow';
import Typography from '@mui/material/Typography';
import React, { useEffect, useState } from 'react';
import FuseSvgIcon from '@fuse/core/FuseSvgIcon';
import Box from '@mui/material/Box';
import Badge from '@mui/material/Badge';
import FileItem from '../file/FileItem';
import VideoCallItem from '../chime/VideoCallItem';
import PostVideoPlayer from 'app/shared-components/videojs/PostVideoPlayer';
import ReferralShareItem from 'app/shared-components/referral/ReferralShareItem';
import MissingReferralItem from 'app/shared-components/referral/MissingReferralItem';
import { selectUser } from 'app/store/userSlice';
import { addChannel } from 'app/store/channelsSlice';
import { fetchPostsByChannelId, deletePost, submitPostInteraction, deletePostInteraction, selectPostById, TYPE_VIDEO_CALL } from 'app/store/postSlice';
import { selectChannel } from 'app/store/channelsSlice';
import { useSelector, useDispatch } from 'react-redux';
import LinkDisplay from 'app/shared-components/util/LinkDisplay';
import LinkMetaModel from '../post/LinkMetaModel';
import { confirmationDialog, dispatchResultMessage } from '../utils';
import { startLoading } from 'app/store/utilSlice';
import Mention from '../Mention';
import ChatEdit from './ChatEdit';
import { parsePost } from '../utils';
import Lightbox from "yet-another-react-lightbox";
import renderTextWithLineBreaks from "app/shared-components/util/renderTextWithLineBreaks";
import SharedArticle from '../post/SharedArticle';
import MissingArticleItem from '../article/MissingArticleItem';


function ChatEntry(props) {
  const {postId, rootChannelId, channelType, permissions, openComments, isOrgReferralChan,
         firstOfGroup, lastOfGroup, lastOfChannel, disableComments, viewCommentsHandler} = props;
  const post= useSelector(selectPostById(postId));
  const dispatch = useDispatch();
  const [showComments, setShowComments] = useState(openComments ? true : false);
  const [isClicked, setIsClicked] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [lightboxOpen, setLightboxOpen] = useState(false);
  const [videoContainerWidth, setVideoContainerWidth] = useState('300px');
  const [videoContainerHeight, setVideoContainerHeight] = useState('300px');
  const commentsChannelId= post.commentChannelId;
  const commentChannel= useSelector(selectChannel(commentsChannelId));
  const isCommentsUnread= commentChannel?.unread;
  const user= useSelector(selectUser);
  const isOwner= user.id === post.author?.id;
  const likesPost= post.callerInteraction === 'like';
  const channelId= post.channelId;
  const isComment= Boolean(post.parentPostId);
  const isVideoCall= post.type === TYPE_VIDEO_CALL;
  const isVideo= post?.mediaType && post.mediaType.includes("video");
  const hasReferral= post?.foreignModelKey && post.foreignModelKey.startsWith('OutboundReferral'); 
  const hasSharedArticle= post?.foreignModelKey && post.foreignModelKey.startsWith('Article');
  const referralExists= Boolean(post?.referral);
  const sharedArticleExists= Boolean(post?.article);
  const important= post.important;
  const hasCitations= post?.citations && post.citations.length > 0;
  
  useEffect(() => {
  	//Add comment channel as empty state to the store
  	if (commentsChannelId) {
  	  dispatch(addChannel({channel: {id: commentsChannelId, parentId: channelId, rootId: rootChannelId, channelType: "thread", name: "Comments", reverseSort: true }}));
    	if (showComments){
    		dispatch(fetchPostsByChannelId({channelId: commentsChannelId}));
    	}
  	}
  }, [commentsChannelId])

   
  function togglePostLike() {
	if (likesPost)
		dispatch(deletePostInteraction({postId: postId, channelId: channelId}));
	else
		dispatch(submitPostInteraction({postId: postId, channelId: channelId, interaction: 'like'}));
  }
  
  function handleRemovePost(){
	 confirmationDialog(dispatch, "Delete message?", 
	                   "Are you sure you want to permanently remove this message?",
	 (confirmed) => {
		  if (confirmed){
			 dispatch(startLoading());
			 dispatch(deletePost({ channelId: channelId, postId: postId, rootChannelId: rootChannelId, channelType: channelType, commentChannelId: commentsChannelId })).then((resp) =>
			 {
				dispatchResultMessage(dispatch, resp, "Deleted message");
			 });
	      }
	  }
	);  
  }
  
  function handleClickAttachment(){
	 confirmationDialog(dispatch, "Download file?", 
	                   "Do you want to download this file?",
	 (confirmed) => {
		  if (confirmed){
			   downloadFile(post.attachment);
	    }
	  }
	);  
  }
  
  function handleClickImage(){
     setLightboxOpen(true);
  }
  
  
  function resizeVideo(dimensions){
        if(dimensions.height != videoContainerHeight) setVideoContainerHeight(dimensions.height);
        if(dimensions.width != videoContainerWidth) setVideoContainerWidth(dimensions.width);
  }

  return (
 
    <Card key={post.id} style={{ border:"none", boxShadow: "none", background: "none" }} className="w-full max-w-lg mb-5"
          onClick={() => setIsClicked(!isClicked)}
          sx={{
          '& .MuiCardHeader-root': {
            alignItems: 'start',
            padding:  '0px',
            pb: lastOfChannel ? '96px' : lastOfGroup ? '15px' : '0px',
          },
        }}
    >
      
      <CardHeader
        
        className=""
        avatar={firstOfGroup ? <UserAvatar aria-label="Recipe" user={post.author} /> : <div style={{width: "40px"}}/>}
        action={null}
        disableTypography
        sx={{
	        "& .MuiCardHeader-root": {
	          width: "100%",
	        },
	        "& .MuiCardHeader-content": {
	          width: "100%",
	        }
	    }}
        title={ 
		 firstOfGroup ? 
          <span className="flex items-center space-x-8">
          
            <UserName user={post.author} className="font-normal" color="secondary.main" paragraph={false}/>
            <span>
              {formatDistanceToNow(new Date(post.createdAt), { addSuffix: true })}
            </span>
          </span>
         :
         null
        }
        subheader={
		 <>
		      {!isEditing && 
		      <div className="flex flex-row">
		        {important && 
		          <FuseSvgIcon size={16} color="red" className="mr-4">
                heroicons-solid:exclamation-circle
              </FuseSvgIcon>
		         }
  		      <Typography component="p" style={{fontWeight: important ? '600' : undefined}} >
             {parsePost(post).map((obj, i) => {
      			   if (obj.type === 'mention'){
      				  return <Mention key={i} mention={obj} /> 
      			   } else {
                       return renderTextWithLineBreaks(obj.value);
                   }
      		   })}
            </Typography>
          </div>
		      }

          {isEditing && 
		      <ChatEdit postId={postId} 
		            rootChannelId={rootChannelId} 
		            originalText={post.text}
		            closeEdit={() => setIsEditing(false)} />
		      }
		      
          {isVideoCall && <Box className="max-w-xs max-h-xs"><VideoCallItem channelType={channelType} post={post} user={user} isOwner={isOwner} rootChannelId={rootChannelId}/></Box>}
          {post.mediaURL && !isVideo && <Box className="max-w-xs max-h-xs" onClick={handleClickImage}>
            <img src={post.mediaURL} alt="post" className="rounded-8" />
            <Lightbox
              open={lightboxOpen}
              close={() => setLightboxOpen(false)}
              slides={[{src: post.mediaURL,
                        alternativeText: 'Post Image',
                     }]}
              render={{
                buttonPrev: () => null,
                buttonNext: () => null,
              }}
            /></Box>}
          {post.mediaURL && isVideo && <Box sx={{height: videoContainerHeight, width: videoContainerWidth}}>
                                          <PostVideoPlayer mediaUrl={post.mediaURL} mediaType={post.mediaType} onVideoSize={resizeVideo}/>
                                       </Box>}
          {post.attachment && <Box className="max-w-xs max-h-xs"><FileItem item={post.attachment} onClick={handleClickAttachment}/></Box>}
          {post.linkUrl && <Box className="max-w-xs"><LinkDisplay url={post.linkUrl} metadata={post.linkMetadata}/></Box>}
          {hasReferral &&  <Box className="max-w-sm max-h-sm">{referralExists ? <ReferralShareItem referral={post.referral}
                                                                                                   channelType={channelType}
                                                                                                   permissions={permissions}
                                                                                                   showOwner={post.referral.provider?.id != post.author?.id}
                                                                                                   isOwner={post.referral.provider?.id == user.id}
                                                                                                   rootChannelId={rootChannelId}
                                                                                                   isOrgReferralChan={isOrgReferralChan}
                                                                                                   enableInterest /> : <MissingReferralItem />}</Box>}
          {hasSharedArticle && <Box className="max-w-sm">{sharedArticleExists ? <SharedArticle article={post.article} clickable={true} /> : <MissingArticleItem />}</Box>}

			  
		  {isClicked && 
		  <Box display="flex" flexDirection="row" alignItems="center" justifyItems="left">
		     {!isVideoCall && 
             <Button size="small" aria-label="Like post" onClick={togglePostLike}>
             {likesPost && (
              <FuseSvgIcon size={16} color="secondary">
                heroicons-solid:thumb-up
              </FuseSvgIcon>
              )}
              {!likesPost && (
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:thumb-up
              </FuseSvgIcon>
              )}
              <Typography className="mx-4">Like</Typography>
              <Typography>{post.interactionCount}</Typography>
            </Button>
            }
            {!disableComments && !isComment &&
            	 <Button aria-label="Comments" onClick={() => viewCommentsHandler(post.id, post.commentChannelId)}>
            	   <Badge color="secondary" variant="dot" invisible={!isCommentsUnread} sx={{zIndex: 0}}> 
                   <ChatBubbleLeftRightIcon className="h-16 w-16" />
                </Badge> 
                  <Typography className="mx-4">Comments</Typography>
                  <Typography>{post.commentCount}</Typography>
                </Button>
            }
            {isOwner &&
                <>
                {!isVideoCall && 
            	<Button aria-label="Edit" onClick={() => setIsEditing(true)}>
                  <FuseSvgIcon size={16}>heroicons-outline:pencil</FuseSvgIcon>
                  <Typography className="mx-4">Edit</Typography>
                </Button>
                }
                <Button aria-label="Delete" onClick={handleRemovePost}>
                  <FuseSvgIcon size={16}>heroicons-outline:trash</FuseSvgIcon>
                  <Typography className="mx-4">Delete</Typography>
                </Button>
                </>
            }
         
          </Box>}
		  
		  {!isClicked && <Box display="flex" flexDirection="row" alignItems="center" justifyItems="left">
             {post.interactionCount > 0 && (
			 <>
              {likesPost && (
              <FuseSvgIcon size={16} color="secondary">
                heroicons-solid:thumb-up
              </FuseSvgIcon>
              )}
              {!likesPost && (
              <FuseSvgIcon size={16} color="action">
                heroicons-outline:thumb-up
              </FuseSvgIcon>
              )}
              <Typography component="span" className="ml-1 mr-6">{post.interactionCount} </Typography>
             </>
             )}
             
             {post.commentCount > 0 && !disableComments && (
			 <>
			        <Badge color="secondary" variant="dot" sx={{marginRight: '4px', zIndex: 0}} invisible={!isCommentsUnread}> 
                  <ChatBubbleLeftRightIcon className="h-16 w-16" onClick={() => viewCommentsHandler(post.id, post.commentChannelId)} />
              </Badge>
              <Typography component="span" className="ml-1">{post.commentCount}</Typography>
             </>
             )}
			
          </Box>

		  }	 	  
	    </>
		}
      />
    </Card>
      
  );
}

function downloadFile(item){
    if (!item) return;
    var link=document.createElement('a');
    link.href = item.objectUrl;
    link.download = item.name;
    link.target = '_blank'; 
    link.click();
}
  
export default ChatEntry;
